import React from 'react';

import classNames from 'classnames';

import styles from './FlyAILoader.module.less';

interface FlyAILoaderProps {
  className?: string;
  children?: React.ReactNode;
}

export const FlyAILoader = ({
  className,
  children = null,
  ...rest
}: FlyAILoaderProps) => {
  return (
    <div {...rest} className='flex items-center'>
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        xmlns='http://www.w3.org/2000/svg'
        className={classNames(className, styles.svgContainer)}
      >
        <circle className={styles.orbit} cx='8' cy='8' r='7.5' />
        <circle className={styles.orbitSpin} cx='8' cy='8' r='7.5' />
        <g clipPath='url(#circleClip)'>
          <g className={styles.zoom}>
            <path
              className={styles.spin}
              d='M6.44444 11.8889L6.04311 10.8047C5.51733 9.38289 5.25444 8.672 4.73567 8.15322C4.21689 7.63444 3.506 7.37156 2.08422 6.84578L1 6.44444L2.08422 6.04311C3.506 5.51733 4.21689 5.25367 4.73567 4.73567C5.25444 4.21767 5.51733 3.506 6.04311 2.08422L6.44444 1L6.84578 2.08422C7.37156 3.506 7.63522 4.21689 8.15322 4.73567C8.67122 5.25444 9.38289 5.51733 10.8047 6.04311L11.8889 6.44444L10.8047 6.84578C9.38289 7.37156 8.672 7.63444 8.15322 8.15322C7.63444 8.672 7.37156 9.38289 6.84578 10.8047L6.44444 11.8889Z'
              fill='var(--fly-color-scheme-primary-6)'
            />
          </g>
          <g className={styles.zoom}>
            <path
              className={styles.spinReverse}
              d='M12.6667 15L12.4948 14.5357C12.2692 13.9259 12.1564 13.621 11.9348 13.3993C11.7123 13.1769 11.4074 13.0641 10.7977 12.8393L10.3333 12.6667L10.7984 12.4948C11.4074 12.2692 11.7123 12.1564 11.934 11.9348C12.1564 11.7123 12.2692 11.4074 12.494 10.7977L12.6667 10.3333L12.8386 10.7977C13.0641 11.4074 13.1769 11.7123 13.3986 11.934C13.621 12.1564 13.9259 12.2692 14.5357 12.494L15 12.6667L14.5349 12.8386C13.9259 13.0641 13.621 13.1769 13.3993 13.3986C13.1769 13.621 13.0641 13.9259 12.8393 14.5357L12.6667 15Z'
              fill='var(--fly-color-scheme-primary-6)'
            />
          </g>
        </g>
      </svg>
      {children && children}
    </div>
  );
};
